export default {"src":"/_next/static/media/Cardfinans.82d7fb3a.svg","height":12,"width":72};